import request from './request';
import updateCart from './updateCart';

const SELECTORS = {
  WRAPPER: '.js-add-to-cart',
  FIELD_COUNT: '.js-add-to-cart-field-count',
  BTN: '.js-add-to-cart-btn',
};

const URL = '/ajax/addToCart.php';
const ERROR_MESSAGE = 'Произошла ошибка при добавлении товара';

const LOADING_CLASSNAME = 'loading';
const ADDED_CLASSNAME = 'added';

function startAddToCard() {
  const send = async (productId, count) => {
    const formData = new FormData();
    formData.append('productId', productId);
    formData.append('count', count);
    const response = await request(URL, 'POST', formData);
    if (response.status !== 200) {
      throw new Error(`Status: ${response.status}`);
    }
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest(SELECTORS.BTN);

    if (!btn) return;

    event.preventDefault();

    const wrapper = btn.closest(SELECTORS.WRAPPER);
    const fieldCount = wrapper.querySelector(SELECTORS.FIELD_COUNT);
    const { productId } = wrapper.dataset;
    const count = fieldCount.value;

    try {
      wrapper.classList.add(LOADING_CLASSNAME);
      await send(productId, count);
      await updateCart();
      wrapper.classList.add(ADDED_CLASSNAME);
    } catch (error) {
      alert(ERROR_MESSAGE);
      console.error(error);
    } finally {
      wrapper.classList.remove(LOADING_CLASSNAME);
    }
  });
}

export default startAddToCard;
